import { Component, OnInit, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Auth } from '@aws-amplify/auth';
import { AuthService } from '../auth/auth.service';
import { Constant } from '../constant';
import { Title } from '@angular/platform-browser';
import { CommonUtil } from '../util/common-util';
import { ToastUtil } from '../util/toast-util';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    selector: 'organization-about',
    templateUrl: './organization-about.component.html',
    styleUrl: './organization-about.component.css',
    standalone: true,
    imports: [
      MatMenuModule,
      MatButtonModule,
      MatIconModule,
      CommonModule,
      ReactiveFormsModule,
      MatFormFieldModule,
      MatSelectModule,
      MatInputModule,
      MatProgressSpinnerModule
    ]
})
export class OrgAboutComponent {
  public tellNo = Constant.calinTellNo + Constant.calinWorkTime;
  public supportMail = Constant.calinSupportMail;
  public accounts;
  public isSaving = false;
  public tagMaster;
  public apiPath = '/company';
  public readonly Constant = Constant;
  public showSpinner = true;
  public form: FormGroup;
  public industryLarges;
  public employeeSizes;
  public locations;
  public jobTypes;
  public employmentTypes;
  public company;

  constructor(
    private title: Title,
    private router: Router,
    private commonUtil: CommonUtil,
    private toastUtil: ToastUtil,
    private dialog: MatDialog,
    private auth: AuthService,
  ) {
    this.title.setTitle(Constant.pageTitleOrganizationAbout + Constant.pageTitleCommon);
    this.industryLarges = [
      { label: '情報通信・IT', value: '0' },
      { label: '製造', value: '1' },
      { label: 'インフラ・建設・運輸', value: '2' },
      { label: '流通', value: '3' },
      { label: 'サービス', value: '4' },
      { label: '金融', value: '5' },
      { label: '医療・ライフサイエンス', value: '6' },
      { label: '公共・教育・研究', value: '7' },
      { label: '農林水産・鉱業', value: '8' },
      { label: 'その他', value: '9' }
    ];
    this.employeeSizes = [
      { label: '〜50人', value: '0' },
      { label: '51〜100人', value: '1' },
      { label: '101〜500人', value: '2' },
      { label: '501〜1,000人', value: '3' },
      { label: '1,001〜3,000人', value: '4' },
      { label: '3,001〜5,000人', value: '5' },
      { label: '5,001〜7,000人', value: '6' },
      { label: '7,001〜9,000人', value: '7' },
      { label: '9,001〜11,000人', value: '8' },
      { label: '11,001〜13,000人', value: '9' },
      { label: '13,001〜15,000人', value: '10' },
      { label: '15,001人〜', value: '11' }
    ];
    this.locations = [
      { label: '単一拠点', value: '0' },
      { label: '複数拠点', value: '1' }
    ];
    this.jobTypes = [
      { label: '現業比率6割以上', value: '0' },
      { label: '事務比率6割以上', value: '1' },
      { label: '現業・事務比率5割', value: '2' }
    ];
    this.employmentTypes = [
      { label: '正規6割以上', value: '0' },
      { label: '非正規6割以上', value: '1' },
      { label: '正規・非正規5割', value: '2' }
    ];
  }

  @HostListener('window:focus')
  onFocus(): void {
    this.commonUtil.checkRefreshToken(this.auth);
  }

  ngOnInit() {
    window.scroll(0, 0);
    if (!this.commonUtil.checkOnline()) {
      this.showSpinner = false;
      return;
    }
    // 記事データを取得する
    this.getCompanyData();
  }

  formatDate(dateStr: string): string {
    //return this.datePipe.transform(
    //  dateStr.replace(' ', 'T'), // MySQL形式対策
    //  'yyyy/MM/dd HH:mm',
    //  'Asia/Tokyo'
    //)!;
    const date = new Date(dateStr.replace(' ', 'T'));

    return date.toLocaleString('ja-JP', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  }

  onSave() {
    if (!this.commonUtil.checkOnline()) {
      this.isSaving = false;
      return;
    }

    if (this.isSaving) {
      return;
    }

    this.isSaving = true;
      this.dataUpdate();
  }

  onSelectChange(select: any) {
    event.preventDefault();
    event.stopPropagation();

    select.close();
    (document.activeElement as HTMLElement)?.blur();
  }

  /*
   * プライベート関数
   */

  // 記事情報を取得する
  private getCompanyData() {
    if (!this.commonUtil.isOnline()) {
      this.toastUtil.showErrorToast(Constant.empty, Constant.msgNetworkError, Constant.toastShowMiliSec);
      return;
    }

    Auth.currentSession().then(session => {
      const apiPath = this.apiPath;
      const options = this.auth.createApiHeader(session);
      this.commonUtil.apiGet(apiPath, options).then(res => {
        if (!res.data) {
          // 削除済み
          this.toastUtil.showErrorToast(Constant.empty, Constant.msgDeleteContentAlreadyError, Constant.toastShowMiliSec);
          return;
        }
        this.company = res.data;
        this.initForm();
        this.showSpinner = false;
      })
      .catch(err => {
        this.commonUtil.debug().log(err);
        if (err.message === Constant.msgLoginFailed) {
          this.commonUtil.showReloadDialog(this.auth);
        } else {
          this.toastUtil.showErrorToast(Constant.empty, Constant.msgNetworkError, Constant.toastShowMiliSec);
          this.showSpinner = false;
        }
      });
    });
  }

  private initForm() {
    this.form = new FormGroup({
      //orgName: new FormControl(this.company.name, [Validators.required]),
      orgName: new FormControl(this.company.name),
      industryLarge: new FormControl(String(this.company.industry_large)),
      employeeSize: new FormControl(String(this.company.employee_size)),
      location: new FormControl(String(this.company.location)),
      jobType: new FormControl(String(this.company.job_type)),
      employmentType: new FormControl(String(this.company.employment_type))
    });

    //this.form.get('orgName')?.disable();

  }

  // トースト表示
  private showToast(msg) {
    this.toastUtil.clearAllShowingToast();
    this.toastUtil.showInformationToast(Constant.empty, msg, Constant.toastShowMiliSec);
  }

  // エラートースト表示
  private showErrorToast(msg) {
    this.toastUtil.clearAllShowingToast();
    this.toastUtil.showErrorToast(Constant.empty, msg, Constant.toastShowMiliSec);
  }

  // 登録実行
  private dataUpdate() {
    Auth.currentSession().then(session => {
      const options = this.auth.createApiHeader(session);
      console.log(options)
      options['body'] = {
        //company_name: this.form.value.orgName,
        industry_large: this.form.value.industryLarge,
        employee_size: this.form.value.employeeSize,
        location: this.form.value.location,
        job_type: this.form.value.jobType,
        employment_type: this.form.value.employmentType
      };
      this.commonUtil
        .apiPut(this.apiPath, options)
        .then(res => {
          if (res.status === Constant.OK) {
            this.toastUtil.showInformationToast('', Constant.msgResultSaveSuccess, Constant.toastShowMiliSec);
            //this.commonUtil.setCompanyName(this.form.value.orgName);
            this.showSpinner = true;
            this.getCompanyData();
            this.isSaving = false;
          }
        })
        .catch(err => {
          this.commonUtil.debug().log(err);
          if (err.message === Constant.msgLoginFailed) {
            this.commonUtil.showReloadDialog(this.auth);
          } else {
            this.toastUtil.showErrorToast('', Constant.msgSaveFailedRetry, Constant.toastShowMiliSec);
          }
          this.isSaving = false;
        });
    });
  }
}
